import { render } from "./App.vue?vue&type=template&id=e4ab7f4c&scoped=true&bindings={\"time\":\"data\",\"openProjects\":\"data\",\"openDropdown\":\"data\",\"openAboutSite\":\"data\",\"openAboutSalmon\":\"data\",\"projects\":\"data\",\"getTime\":\"options\",\"handleDropdown\":\"options\",\"closeDropdown\":\"options\",\"handleKeyDown\":\"options\",\"openSiteModal\":\"options\",\"openSalmonModal\":\"options\",\"closeSiteModal\":\"options\",\"closeSalmonModal\":\"options\",\"closeProjects\":\"options\",\"goTo\":\"options\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=less"
import "./App.vue?vue&type=style&index=1&id=e4ab7f4c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-e4ab7f4c"

export default script